<div class="base" [class.base__blurred]="routerPath.startsWith('/reminders/(full:point')">
  <pp-common-components></pp-common-components>

  @if (user?.userId) {
    <div id="reminderContent" class="remindersContent">
      <pp-reminders-calendar [ppDataFetched]="filterDataFetched"></pp-reminders-calendar>
    </div>
  }
</div>

<router-outlet name="full"></router-outlet>
